import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService, LoggedInUser } from 'app/services/auth/auth.service';
import { API_URL, getProfile } from 'app/helpers/globals';
import { TranslateService } from '@ngx-translate/core';
import { egretAnimations } from 'app/helpers/egret-animations';

const DOWNLOAD_URL = 'https://tacho4safe.com/web/rduadminjson/download_rdu_manager?file=';

@Component({
    selector: 'app-rdu-manager',
    templateUrl: './rdu-manager.component.html',
    styleUrls: ['./rdu-manager.component.css'],
    animations: egretAnimations
})
export class RduManagerComponent implements OnInit {
    readonly isTrackgpsProfile = getProfile().key === 'trackgps';
    loggedInUser: LoggedInUser = null;
    username = '';
    password = '';
    rduManagerAppFileName: string = null;
    isLoading = false;
    errorMessage: string = null;

    constructor(
        private authService: AuthService,
        private http: HttpClient,
        private translateService: TranslateService
    ) { }

    ngOnInit(): void {
        this.loggedInUser = this.authService.getLoggedInUser();
    }

    authenticate(): void {
        if (this.isLoading) return;
        if (!this.isTrackgpsProfile && (!this.username || !this.password)) return;
        this.isLoading = true;
        this.errorMessage = null;

        this.http.post<{ rduManagerAppFileName: string }>(API_URL + 'auth/getFileName', {
            password: this.isTrackgpsProfile ? null : this.password,
            username: this.isTrackgpsProfile ? null : this.username
        }, { withCredentials: true }).subscribe(
            (response) => {
                if (response.rduManagerAppFileName) {
                    this.rduManagerAppFileName = response.rduManagerAppFileName.replace('TSRDUMCManager_', 'FleetTrackGPS_CompanyCardDriver_');
                } else {
                    this.rduManagerAppFileName = null;
                    this.errorMessage = this.translateService.instant('Invalid username or password.');
                }
                this.isLoading = false;
            },
            () => {
                this.rduManagerAppFileName = null;
                this.errorMessage = this.translateService.instant('Invalid username or password.');
                this.isLoading = false;
            }
        );
    }

    downloadFile(): void {
        window.open(DOWNLOAD_URL + encodeURIComponent(this.rduManagerAppFileName), '_blank');
    }
}
